import * as angular from 'angular';
import * as d3 from 'd3';

import { ComponentDefinition, Dictionary, DigitalCorrespondanceTable, DigitalCorrespondanceTableRow, DigitalSet, DigitalState, Pattern } from '@models/index';
import { mapRowsToViewModels } from './buildCorrespondanceTree';
import { TreeRowViewModel } from './TreeRowViewModel';

class CorrespondanceTreeController implements angular.IComponentController {
    correspondanceTree: TreeRowViewModel[];
    maxLevel: number;
    searchCriteria: Pattern<TreeRowViewModel>[];
    selectedLevel: number;
    
    private _correspondanceTree: TreeRowViewModel[];

    readonly digitalSets: Dictionary<DigitalSet>;
    readonly isEditMode: boolean;
    readonly onRowCheckChange: (value: { item: DigitalCorrespondanceTableRow, isChecked: boolean }) => void;
    readonly rows: DigitalCorrespondanceTableRow[];
    readonly table: DigitalCorrespondanceTable;

    static $inject = [];

    $onInit() {
        this.maxLevel = this.maxLevel || 1;
        this.searchCriteria = [
            {
                label: 'Digital set',
                model: 'se',
                placeholder: 'Digital set',
                property: 'se',
                isMatch: (d, value, _orig) => {
                    return d.search.fullSet.filter(s => value.test(s)).length > 0;
                }
            },
            {
                label: 'Digital state',
                model: 'st',
                placeholder: 'Digital state',
                property: 'st',
                isMatch: (d, value, _orig) => {
                    return d.search.fullState.filter(s => value.test(s)).length > 0;
                }
            },
        ];
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['rows']) {
            if (this.digitalSets && this.table && this.rows) {
                this._correspondanceTree = mapRowsToViewModels(this.rows, this.table, this.digitalSets);
                this.maxLevel = d3.max(this._correspondanceTree, d => d.level);
                this.selectedLevel = this.maxLevel;
                this.correspondanceTree = this._correspondanceTree.filter(d => d.level <= this.selectedLevel);
            }
        }
    }

    onCheckChange(item: DigitalCorrespondanceTableRow, isChecked: boolean) {
        if (this.onRowCheckChange) {
            this.onRowCheckChange({ item, isChecked });
        }
    }

    onRowClick(item: TreeRowViewModel) {
        if (this.isEditMode) {
            item.isChecked = !item.isChecked;
            this.onCheckChange(item.model, item.isChecked);
        }
    }

    onLevelChange(level: number) {
        this.correspondanceTree = this._correspondanceTree.filter(d => d.level <= level);
    }
}

export const wtCorrespondanceTree: ComponentDefinition = {
    componentId: 'wtCorrespondanceTree',
    controller: CorrespondanceTreeController,
    template: require('./correspondanceTree.component.html'),
    controllerAs: 'vm',
    bindings: {
        digitalSets: '<',
        isEditMode: '<?',
        onRowCheckChange: '&?',
        rows: '<',
        table: '<'
    }
};
